import { render } from "./SidebarContainer.vue?vue&type=template&id=4e8846f0"
import script from "./SidebarContainer.vue?vue&type=script&lang=js"
export * from "./SidebarContainer.vue?vue&type=script&lang=js"

import "./SidebarContainer.vue?vue&type=style&index=0&id=4e8846f0&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__